export const VIDEO_TYPES = [
  "Full Film",
  "Trailer",
  "Teaser",
  "Commercial",
  "Music Video",
  "Other",
];

export function getVideoLabel(type) {
  switch (type) {
    case "Full Film":
      return "Play Film";
    case "Trailer":
      return "Watch Trailer";
    case "Teaser":
      return "Watch Teaser";
    default:
      return "Play";
  }
}

export function getVideoName(title, type) {
  switch (type) {
    case "Trailer":
      return `${title} Trailer`;
    case "Teaser":
      return `${title} Teaser`;
    case "Full Film":
      return title;
    default:
      return `${title} Video`;
  }
}
